var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
define(["require", "exports"], function (require, exports) {
    "use strict";
    var LookupDataSources = /** @class */ (function () {
        function LookupDataSources() {
            var self = this;
            self.init();
        }
        LookupDataSources.prototype.createLookupDataSource = function (name, customOptions) {
            var options = __assign({ pageSize: 100, serverPaging: true, serverFiltering: true, serverSorting: true, serverAggregates: true }, customOptions);
            console.log("Creating lookup data source: " + name, customOptions, options);
            var dataFunction = function () { return {}; };
            if (options && options.dataFunction) {
                dataFunction = options.dataFunction;
            }
            return new kendo.data.DataSource({
                transport: {
                    read: {
                        url: "/LookupDataSources/".concat(name),
                        type: "POST",
                        dataType: "json",
                        data: dataFunction
                    },
                },
                schema: {
                    data: function (response) { return response.Data; },
                    total: "Total",
                    errors: "Errors"
                },
                pageSize: options.pageSize ? options.pageSize : 100,
                serverPaging: options ? options.serverPaging : true,
                serverFiltering: options ? options.serverFiltering : true,
                serverSorting: options ? options.serverSorting : true,
                serverAggregates: options ? options.serverAggregates : true
            });
        };
        LookupDataSources.prototype.init = function () {
            var self = this;
        };
        return LookupDataSources;
    }());
    return LookupDataSources;
});
//# sourceMappingURL=LookupDataSources.js.map


//////////////////
// WEBPACK FOOTER
// ./build/utils/LookupDataSources.js
// module id = 11
// module chunks = 2